import { render, staticRenderFns } from "./QuestionLine.vue?vue&type=template&id=245c2e80&scoped=true"
import script from "./QuestionLine.vue?vue&type=script&lang=ts"
export * from "./QuestionLine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245c2e80",
  null
  
)

export default component.exports